import React, { Component } from 'react';
import { motion } from "framer-motion";

export default function HamburgerMenu(){

    return(
        <motion.div 
        animate={{ x: -400 }}
        transition={{ duration: 1 }}
        >
            <nav  className='hamburgerMenu'>
                
                <a className='hamburgerLink' href='#landing_page'>
                    HOME
                </a>
                <a className='hamburgerLink'  href='#about-us'>
                    ABOUT US
                </a>
                <a className='hamburgerLink'  href='#services'>
                    SERVICES
                </a>
                <a className='hamburgerLink'  href='#contact-form'>
                    CONTACT
                </a>
            </nav>
        </motion.div>
    )
}